import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { encryptedKeyByRsaKeyValidator, objectValidator, publicKeyValidator, signedEntityByRsaKeyValidator, uuidValidator, } from '#validation';
import { workspaceNameValidator } from '#validation/workspace';
import { GuestInvitationCreateSchema, OwnerInvitationCreateSchema, } from '#web-service-api/invitation/request';
import { EnsureSsoCryptoSchema, EnsureWorkspaceCryptoSchema, } from './ensure-sso-crypto.dto';
export const WorkspaceCreateSchema = z.object({
    id: uuidValidator({
        requiredError: 'workspace.id.required',
        formatError: 'workspace.id.uuid',
    }),
    name: workspaceNameValidator,
    adminPublicKey: publicKeyValidator,
    everyonePublicKey: publicKeyValidator,
    eEveryonePrivateKeyByAdminKey: encryptedKeyByRsaKeyValidator,
    sEveryoneByAdminKey: signedEntityByRsaKeyValidator,
    eWorkspaceCommonKeyByAdminKey: encryptedKeyByRsaKeyValidator,
    // Those two are alternatives prefer workspaceCrypto over ssoCrypto
    workspaceCrypto: EnsureWorkspaceCryptoSchema.optional(),
    /**
     * @deprecated
     *
     * Use: `workspaceCrypto`
     *
     * Date: 2025-10-30
     */
    ssoCrypto: EnsureSsoCryptoSchema.optional(),
    invitation: objectValidator({
        object: OwnerInvitationCreateSchema,
        requiredError: 'workspace.invitation.required',
    }),
    guestInvitation: GuestInvitationCreateSchema.optional(),
    awsMarketplaceContractId: z.number().optional(),
    partnerOrganizationId: uuidValidator({
        formatError: 'workspace.partnerOrganization.partnerOrganizationId.uuid',
    }).optional(),
});
export class WorkspaceCreateDto extends createZodDto(WorkspaceCreateSchema) {
}
